export default "__VITE_ASSET__BgJ7ppR2__"